module.exports = __webpack_public_path__ + "static/media/Feature.7e1f7e61.png";